import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import Icon from '@components/Icon/Icon';
import RoundedButton from '@components/RoundedButton/index';

import { useSession } from '@hooks/useSession';

import { PaymentModal } from './PaymentModalContent.style';

const messages = defineMessages({
  paymentConfirmed: {
    id: 'paymentModalContent.paymentConfirm',
    defaultMessage: 'Payment confirmed',
  },
  accountCreated: {
    id: 'paymentModalContent.accountCreated',
    defaultMessage: 'Account created',
  },
  sentEmail: {
    id: 'paymentModalContent.sentEmail',
    defaultMessage: "We've sent you a confirmation email for your records.",
  },
  sentEmailBehalf: {
    id: 'paymentModalContent.sentEmailBehalf',
    defaultMessage:
      'A confirmation email has been sent to the account user(s).',
  },
  sendEmailLater: {
    id: 'paymentModalContent.sendEmailLater',
    defaultMessage: "Email invitations can be sent from the user's profile.",
  },
  continue: {
    id: 'GLOBAL.continue',
    defaultMessage: 'Continue',
  },
});

interface PaymentModalContentProps {
  inputCallback?: () => void;
  didPay?: boolean;
  didSendEmail?: boolean;
}

function PaymentModalContent({
  inputCallback,
  didPay = true,
  didSendEmail = true,
}: PaymentModalContentProps) {
  const {
    state: { isCurator, isAdmin },
  } = useSession();
  const { formatMessage } = useIntl();
  const isBehalf = isCurator || isAdmin;
  return (
    <PaymentModal>
      <div>
        <Icon
          color="success.main"
          name="circle-check"
          style={{ fontSize: 72 }}
        />
      </div>
      <h2>
        {formatMessage(
          didPay ? messages.paymentConfirmed : messages.accountCreated
        )}
      </h2>
      <p>
        {didSendEmail
          ? formatMessage(
              isBehalf ? messages.sentEmailBehalf : messages.sentEmail
            )
          : formatMessage(messages.sendEmailLater)}
      </p>

      <RoundedButton onClick={() => inputCallback?.()}>
        {formatMessage(messages.continue)}
      </RoundedButton>
    </PaymentModal>
  );
}

export default PaymentModalContent;
